import { Injectable } from '@angular/core';
import { BaseJsonService } from '@shared/services/base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResponse } from '@shared/models';
import { Shipment, ShipmentServiceProvider, TrackingNumber } from 'src/models/orders/orderDetails/shipment.model';
import { TrackingLinkViewModel } from 'src/models/orders/tracking/tracking.link.view.model';
import { SelectItem } from 'src/models/general/select.item.model';

@Injectable({
	providedIn: 'root'
})
export class OrderShipmentService extends BaseJsonService {
	getShipments(orderUuid: string): Observable<Shipment[]> {
		const url = this.generateUrl(this.services.order, '%s/%s', 'import/shipment', orderUuid);

		return this.http.get<ListResponse<Shipment>>(url, this.options).pipe(
			map((res: ListResponse<Shipment>) => {
				return res.data;
			})
		);
	}

	getShipmentProviders(): Observable<ShipmentServiceProvider[]> {
		const url = this.generateUrl(this.services.order, '%s', 'import/shippingserviceprovider');

		return this.http.get<ListResponse<ShipmentServiceProvider>>(url, this.options).pipe(
			map((res: ListResponse<ShipmentServiceProvider>) => {
				return res.data;
			})
		);
	}

	updateShipments(shipment: Shipment): Observable<void> {
		const url = this.generateUrl(this.services.order, '%s', 'import/shipment');
		return this.http.put<void>(url, shipment, this.options);
	}

	mapShipmentsToTrackingLinkViewModels(data: [ShipmentServiceProvider[], Shipment[]]): TrackingLinkViewModel[] {
		const providers: ShipmentServiceProvider[] = data[0];
		const shipments: Shipment[] = data[1];
		const links: TrackingLinkViewModel[] = [];

		shipments.forEach((shipment: Shipment) => {
			shipment.trackingNumbers.forEach((trackingNumber: TrackingNumber) => {
				const provider = providers.find((ssp: ShipmentServiceProvider) => {
					return ssp.name === trackingNumber.serviceProvider;
				});

				if (!provider) {
					throw Error('no Provider found for ' + trackingNumber.serviceProvider);
				}

				links.push({
					trackingNumber: trackingNumber.trackingNumber,
					link: provider.trackingLink.replace('#IdentCode#', trackingNumber.trackingNumber)
				});
			});
		});

		return links;
	}

	getShipmentProvidersAsSelectItem(): Observable<SelectItem[]> {
		return this.getShipmentProviders().pipe(
			map((providers: ShipmentServiceProvider[]) => {
				return providers.map((provider: ShipmentServiceProvider) => {
					return {
						id: provider.name,
						value: provider.name
					};
				});
			})
		);
	}
}


